import React, { useEffect } from "react"
import { Card, CardContent } from "../../../ui/card"
import { Heart, Rocket, Lightbulb, Users } from "lucide-react"
import AOS from "aos"
import "aos/dist/aos.css"

const CultureSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out"
    })
  }, [])

  const values = [
    {
      icon: <Heart className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple" />,
      title: "People First",
      description:
        "We treat each other like family—supporting, celebrating, and growing together. Every voice matters here."
    },
    {
      icon: <Rocket className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple" />,
      title: "Think Big, Move Fast",
      description:
        "We dream up wild ideas and then make them real. No bureaucracy or red tape—just rapid experimentation."
    },
    {
      icon: <Lightbulb className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple" />,
      title: "Create with Purpose",
      description:
        "Every feature we build solves real problems for creators. We're obsessed with making meaningful impact."
    },
    {
      icon: <Users className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple" />,
      title: "Better Together",
      description:
        "We believe magic happens when diverse perspectives collide. Collaboration is our superpower."
    }
  ]

  return (
    <section className="py-8 sm:py-10 md:py-12 lg:py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-10 md:mb-12" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 md:mb-5 text-black">
            The culture that makes us{" "}
            <span className="text-[#E563A4]">different</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            Working at Oye Creator isn't just another job. It's a place where
            you'll grow, laugh, create, and build something amazing with people
            you genuinely care about.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {values.map((value, index) => (
            <Card
              key={index}
              className="border-2 border-solid border-gray-100 hover:border-oye-purple/20 transition-all duration-300 hover:shadow-lg hover:translate-y-[-5px] rounded-xl md:rounded-2xl"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <CardContent className="pt-4 sm:pt-5 md:pt-6 px-4 sm:px-5 h-full flex flex-col">
                <div className="mb-3 md:mb-4 bg-oye-light-purple p-2 sm:p-3 rounded-lg md:rounded-xl w-fit">
                  {value.icon}
                </div>
                <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3">
                  {value.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600">
                  {value.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CultureSection
